import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ContentIcon, { HEADING_POLL } from "ContentIcon";
import NoContent, { NO_POLLS } from "NoContent";
import LocaleStrings from "Languages";

class Polls extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_POLL} />
          </div>
        </div>
        <div className="clearfix"></div>

        <NoContent contentType={NO_POLLS} />
        <div className="text-center p-20">
          <Link to="/dashboard/polls">
            <button className="btn btn-primary text-uppercase">
              {LocaleStrings.polls_clickhere}
            </button>
          </Link>
        </div>
        <div className="clearfix">&nbsp;</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
  };
}
export default connect(mapStateToProps)(Polls);
